
import { defineComponent, ref } from "vue";
import { IonSelect, IonSelectOption, IonItem } from "@ionic/vue";
import TradeRepository from "@/repositories/TradeRepository";

export default defineComponent({
  components: { IonSelect, IonSelectOption, IonItem },

  setup() {
    const selected = ref(0);

    const trades = TradeRepository.trades();

    const changeQuarter = (): void => {
      TradeRepository.setSelectedIndex(selected.value);
    };

    return {
      changeQuarter,
      selected,
      trades,
    };
  },
});
